import type { Term } from '@/types/models'
import { PrimaryFocus } from '../primaryFocus/constant'
import { isNonEmptyString } from '@/utils/checks'

export const generateInsuranceCarouselSubTitle = ({
  location,
  term,
  primaryFocus
}: {
  primaryFocus?: PrimaryFocus
  location?: string
  term?: Term['title']
}): string => {
  const lowerCasedTerm = isNonEmptyString(term) ? term.toLowerCase() : ''

  if (!isNonEmptyString(primaryFocus) && !isNonEmptyString(location)) {
    return `Insurance typically covers treatment.`
  }
  if (!isNonEmptyString(primaryFocus)) {
    return `${location} insurance plans typically cover treatment.`
  }

  if (
    !isNonEmptyString(location) &&
    primaryFocus === PrimaryFocus.SUBSTANCE_USE
  ) {
    return `Insurance typically covers addiction treatment.`
  }

  if (primaryFocus === PrimaryFocus.SUBSTANCE_USE) {
    return `${location} insurance plans typically cover mental health and addiction treatment.`
  }

  if (isNonEmptyString(term) && isNonEmptyString(location)) {
    return `${location} insurance typically covers ${lowerCasedTerm} treatment.`
  }

  if (!isNonEmptyString(location) && isNonEmptyString(term)) {
    return `Insurance typically covers ${lowerCasedTerm} treatment.`
  }

  if (!isNonEmptyString(term)) {
    return `${location} insurance plans typically cover treatment.`
  }
  return `${location} insurance plans typically cover ${lowerCasedTerm} treatment.`
}
